import serviceRequest from "utils/request";

const baseUrl = "/ref/data";
let batchRefDataRequest = null;

export const queryRefData = (param) => {
	return serviceRequest({
		url: `${baseUrl}/query`,
		method: "post",
		data: param,
	});
};

export const batchQueryRefData = (param) => {
	if (batchRefDataRequest) {
		return batchRefDataRequest;
	}
	batchRefDataRequest = serviceRequest({
		url: `${baseUrl}/batch/query`,
		method: "post",
		data: param,
	}).catch((error) => {
		batchRefDataRequest = null;
		throw error;
	});
	return batchRefDataRequest;
};
